import { render, staticRenderFns } from "./ApiMetricsCard.vue?vue&type=template&id=212165a1&scoped=true&"
import script from "./ApiMetricsCard.vue?vue&type=script&lang=js&"
export * from "./ApiMetricsCard.vue?vue&type=script&lang=js&"
import style0 from "./ApiMetricsCard.vue?vue&type=style&index=0&id=212165a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212165a1",
  null
  
)

export default component.exports